import React, { useEffect, useState } from 'react'
import PropTypes from "prop-types";
import GridToggleButton from '../ui/toggleButton/GridToggleButton';

const RenderGridToggleColumn = ({ rowData, col, rowIndex, onColumnDataChange }) => {

    const [value, setValue] = useState(rowData[col.fieldName]);

    const isDisabled = col.colSettings ? col.colSettings.isDisabled : false;

    useEffect(() => {
        setValue(rowData[col.fieldName])
    }, [rowData, col.fieldName]);

    if (rowData.emailAddress === "GlobalAdmin@mol-tech.com") {
        return null;
    }

    const handleChange = () => {
        let isChecked = !value;
        setValue(isChecked);

        if (onColumnDataChange) {
            const newRowData = { ...rowData, [col.fieldName]: isChecked };
            onColumnDataChange(col.fieldName, newRowData, rowIndex);
        }
    }

    return (
        <GridToggleButton
            id={`toggle-button_${rowIndex}`}
            isChecked={value}
            isDisabled={isDisabled}
            {...col}
            onChange={() => handleChange()}
        />
    )
}

RenderGridToggleColumn.propTypes = {
    rowData: PropTypes.object.isRequired,
    col: PropTypes.shape({
        fieldName: PropTypes.string.isRequired,
        colSettings: PropTypes.shape({
            isDisabled: PropTypes.bool
        })
    }).isRequired,
    rowIndex: PropTypes.number.isRequired,
    onColumnDataChange: PropTypes.func.isRequired,
};

export default RenderGridToggleColumn